import React, { createContext, useContext, useState, type ReactNode } from 'react';
import { gtagService } from '../services/gtagService';

interface FlyingItem {
  id: string;
  startPosition: { x: number; y: number };
  imageUrl: string;
}

interface FlyingCartContextType {
  triggerFlyingAnimation: (startPosition: { x: number; y: number }, imageUrl: string) => void;
  flyingItems: FlyingItem[];
  removeFlyingItem: (id: string) => void;
}

const FlyingCartContext = createContext<FlyingCartContextType | undefined>(undefined);

export const FlyingCartProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [flyingItems, setFlyingItems] = useState<FlyingItem[]>([]);

  const triggerFlyingAnimation = (startPosition: { x: number; y: number }, imageUrl: string) => {
    const id = `flying-${Date.now()}-${Math.random()}`;
    setFlyingItems(prev => [...prev, { id, startPosition, imageUrl }]);
    
    // Track flying cart animation
    gtagService.trackFlyingCartAnimation();
  };

  const removeFlyingItem = (id: string) => {
    setFlyingItems(prev => prev.filter(item => item.id !== id));
  };

  return (
    <FlyingCartContext.Provider value={{ triggerFlyingAnimation, flyingItems, removeFlyingItem }}>
      {children}
    </FlyingCartContext.Provider>
  );
};

export const useFlyingCart = () => {
  const context = useContext(FlyingCartContext);
  if (context === undefined) {
    throw new Error('useFlyingCart must be used within a FlyingCartProvider');
  }
  return context;
};